/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useRef } from "react";
import dayjs from "dayjs";
import { makeObservable, observable, action } from "mobx";
import { Props as DataGridProps } from "../components/DataGrid/DataGrid";
import { getTemplates } from "../api/Templates";
import { UtcDateFormatter } from "../utils/dateformat/dateFormat";
import { Cookies } from "react-cookie";
import ListModerationBtn from "../pages/Moderation/ListModerationBtn";
import Avatar from "@mui/material/Avatar";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { defaultAllCode } from "../pages/Templates/LanguageCode";
import { defaultAllCategory } from "../pages/Templates/CategoryCode";
import { getItem } from "../utils/nauth";
import { postHistory } from "../api/History";
import * as Assets from "../components/Icon/assets";
import ListReviewerBtn from "../pages/Moderation/ListReviewerBtn";
import {
  CircularProgress,
  Box,
  Card,
  CardMedia,
  Dialog,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  Link,
} from "@mui/material";
import { getTempalteDetails } from "../api/Templates";
import { DetailRequestProps } from "../api/types";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { styled } from "@mui/system";
import NoImg from "../components/Icon/assets/NoImg.png";
import useKeyPress from "../utils/custom/useKeyPress";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { getAccountServerType, getTemplatesServerType } from "../constants";

const cookies = new Cookies();
const getCookie = (item: string) => {
  return cookies.get(item);
};
const userEmail = getItem("email") || getItem("name") || "No name";

class ModerationStore {
  constructor() {
    makeObservable(this, {
      application: observable,
      status: observable,
      startDate: observable,
      endDate: observable,
      searchText: observable,
      searchOption: observable,
      gridOption: observable,
      headerStatus: observable,
      language: observable,
      category: observable,
      mixability: observable,
      reference: observable,
      asset: observable,
      entertainment: observable,
      gacha: observable,
      isReviewer: observable,
      badge: observable,
    });
  }

  application = getCookie("mApplication") ? getCookie("mApplication") : "all";
  status = getCookie("mStatus") ? getCookie("mStatus") : "InReview";

  nowDate = dayjs().toDate();
  startDate = window.location.pathname.includes("userid")
    ? dayjs().subtract(1, "month").toDate()
    : getCookie("mStartDate")
    ? getCookie("mStartDate")
    : dayjs().subtract(1, "month").toDate();

  endDate: Date = window.location.pathname.includes("userid")
    ? dayjs().toDate()
    : getCookie("mEndDate")
    ? dayjs(getCookie("mEndDate"), "yyyy/MM/dd").toDate()
    : dayjs().toDate();

  searchText = "";
  searchOption = "templateId";
  headerStatus = localStorage.getItem("columns") || "";
  language = getCookie("mLanguage") ? getCookie("mLanguage") : defaultAllCode;
  category = getCookie("mCategory")
    ? getCookie("mCategory")
    : defaultAllCategory;
  mixability = 1;
  reference = 1;
  asset = 1;
  entertainment = 1;
  gacha = true;
  isReviewer = false;
  badge = "none";

  gridOption: DataGridProps = {
    columns: [
      {
        field: "index",
        headerName: "No",
        filterable: false,
        renderCell: (index) =>
          index.api.getRowIndex(index.row.id) +
          1 +
          this.gridOption.page * this.gridOption.rowsPerPage,
        width: 50,
        align: "center",
        hide: this.headerStatus.includes("index"),
      },
      {
        field: "link",
        headerName: "Link",
        width: 80,
        align: "center",
        headerAlign: "center",
        hide: this.headerStatus.includes("link"),
        renderCell: () => {
          return (
            <>
              <img
                src={Assets.NewWindows}
                alt="new window"
                style={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                }}
              />
            </>
          );
        },
      },
      {
        field: "thumbnail",
        headerName: "Thumbnail",
        width: 640,
        headerAlign: "center",
        renderCell: (param) => {
          const [openModerAlert, setModerAlert] = useState<boolean>(false);
          const [imageIndex, setImageIndex] = useState<number>(0);
          const userLang = navigator.language || "en";
          const [image, setImage] = useState(
            param.row.thumbnailsPaths && param.row.thumbnailsPaths.length > 0
              ? param.row.thumbnailsPaths[0]
              : NoImg
          );

          const videoRef = useRef<HTMLVideoElement | null>(null);
          const [speed, setSpeed] = useState(getCookie("videoSpeed") || 1);

          const [detailLoading, setDetailLoading] = useState<boolean>(false);
          const [appName, setAppName] = useState("");
          const [appVersion, setAppVersion] = useState("");
          const [OS, setOS] = useState("");
          const [kineInfo, setKineInfo] = useState(param.row.kineInfo);

          const [forbiddenWord, setForbiddenWord] = useState(
            param.row.forbiddenWords
          );

          const imgWidth =
            (Number(param.row.ratios.split(":")[0]) /
              Number(param.row.ratios.split(":")[1])) *
            350;

          const handleSpeedChange = (newSpeed: number) => {
            if (videoRef.current) {
              videoRef.current.playbackRate = newSpeed;
              setSpeed(newSpeed);
            }
          };

          const enlargeImage = async () => {
            const data: DetailRequestProps = {
              data: param.row.templateId,
            };
            await getTempalteDetails(data).then((res) => {
              if (res.response?.status) {
                setDetailLoading(true);
              } else {
                setAppName(res.userAgent.appName);
                setAppVersion(res.userAgent.appVersion);
                setOS(res.userAgent.os);
              }
            });
            setImageIndex(0);
            setImage(param.row.thumbnailsPaths[0]);
            setModerAlert(true);
          };

          const changeImage = (index: number) => {
            if (index === 5) {
              setImage(param.row.videoPath);
              setImageIndex(5);
            } else {
              setImage(param.row.thumbnailsPaths[index]);
              setImageIndex(index);
            }
          };

          const backImage = (index: number) => {
            if (index < 0) {
              setImageIndex(5);
              setImage(param.row.videoPath);
            } else {
              setImageIndex(index);
              setImage(param.row.thumbnailsPaths[index]);
            }
          };

          const forwardImage = (index: number) => {
            if (index > 5) {
              setImageIndex(0);
              setImage(param.row.thumbnailsPaths[0]);
            } else {
              setImageIndex(index === 5 ? 5 : index);
              setImage(
                index === 5
                  ? param.row.videoPath
                  : param.row.thumbnailsPaths[index]
              );
            }
          };

          const encodeString = (text: string) => {
            return encodeURIComponent(text);
          };

          const wordMatching = (text: string, forbiddenWords: any) => {
            const highlightForbiddenWords = (
              text: string,
              forbiddenWords: any
            ) => {
              let result = [];
              let startIndex = 0;

              for (let i = 0; i < text.length; i++) {
                for (const { keyword } of forbiddenWords) {
                  if (
                    text.slice(i, i + keyword.length).toLowerCase() ===
                    keyword.toLowerCase()
                  ) {
                    if (startIndex !== i) {
                      result.push(text.slice(startIndex, i));
                    }
                    result.push(
                      <b>
                        <span style={{ color: "red" }}>
                          {text.slice(i, i + keyword.length)}
                        </span>
                      </b>
                    );
                    startIndex = i + keyword.length;
                    i += keyword.length - 1;
                    break;
                  }
                }
              }

              if (startIndex < text.length) {
                result.push(text.slice(startIndex));
              }

              return result;
            };

            return (
              <div>
                {highlightForbiddenWords(text, forbiddenWords)}
                <Link
                  sx={{
                    pt: "3px",
                  }}
                  href={`https://translate.google.co.kr/?sl=auto&hl=${userLang}&text=${encodeString(
                    param.row.translations[0].description
                  )}`}
                  target="_blank"
                >
                  <GTranslateIcon
                    sx={{
                      fontSize: "large",
                      cursor: "pointer",
                      color: "#6666ff",
                      minWidth: "25px",
                    }}
                  />
                </Link>
              </div>
            );
          };

          const keywordString = (item: any) => {
            const forbiddenKeywords = item.map((word: any) => word.keyword);

            return forbiddenKeywords.join(", ");
          };

          const handleKeyDown = async (event: KeyboardEvent) => {
            let element: HTMLElement = event.target as HTMLElement;
            if (element) {
              switch (element.tagName) {
                case "INPUT":
                case "LI":
                case "TEXTAREA":
                case "BUTTON":
                  break;
                default:
                  if (event.key === "ArrowRight") {
                    forwardImage(imageIndex + 1);
                  } else if (event.key === "ArrowLeft") {
                    backImage(imageIndex - 1);
                  } else if (event.key === "Enter") {
                    setModerAlert(false);
                  }
                  break;
              }
            }
          };

          useKeyPress(
            ["ArrowRight", "ArrowLeft", "Escape", "Enter"],
            handleKeyDown
          );

          const handleEscape = (
            // 위의 handleKeyDown 함수에서 Escape(ESC 단축키)가 적용되지 않아 함수를 따로 뺴서 사용
            event: React.KeyboardEvent<HTMLDivElement>
          ) => {
            if (event.key === "Escape") {
              setModerAlert(false);
            }
          };

          const ImageCard = styled(Card)({
            "&.selectedImage": {
              border: "2px solid red",
            },
          });

          const ImageCardMedia = styled(CardMedia)({
            "&.selectedImage": {
              border: "2px solid red",
            },
          });

          return (
            <>
              <Box>
                <Box
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {param.row.thumbnailsPaths &&
                  param.row.thumbnailsPaths.length > 0 ? (
                    param.row.thumbnailsPaths.map(
                      (item: any, index: number) => {
                        return (
                          <>
                            <div
                              key={"div" + index}
                              style={{
                                maxWidth: "120px",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                              onClick={enlargeImage}
                            >
                              <img
                                style={{
                                  height: "calc(100% - 10px)",
                                  maxHeight: "160px",
                                  maxWidth: "120px",
                                }}
                                src={item}
                                key={"img" + index}
                              />
                            </div>
                            &nbsp;
                          </>
                        );
                      }
                    )
                  ) : (
                    <div
                      style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        style={{
                          height: "calc(100% - 10px)",
                          maxWidth: "120px",
                        }}
                        src={NoImg}
                      />
                    </div>
                  )}
                </Box>
                <Box
                  sx={{
                    maxWidth: "620px",
                    display: "flex",
                  }}
                >
                  <Typography
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "590px",
                    }}
                  >
                    {forbiddenWord ? (
                      wordMatching(
                        param.row.translations[0].description.trim(),
                        forbiddenWord
                      )
                    ) : (
                      <>
                        Description :{" "}
                        {param.row.translations[0].description.trim()}
                        <Link
                          sx={{
                            pt: "3px",
                          }}
                          href={`https://translate.google.co.kr/?sl=auto&hl=${userLang}&text=${encodeString(
                            param.row.translations[0].description
                          )}`}
                          target="_blank"
                        >
                          <GTranslateIcon
                            sx={{
                              fontSize: "large",
                              cursor: "pointer",
                              color: "#6666ff",
                              minWidth: "25px",
                            }}
                          />
                        </Link>
                      </>
                    )}
                  </Typography>
                </Box>
                {forbiddenWord && (
                  <Box>
                    <Typography
                      sx={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "590px",
                      }}
                    >
                      Forbidden Word :{" "}
                      <b style={{ color: "red" }}>
                        {keywordString(forbiddenWord)}
                      </b>
                    </Typography>
                  </Box>
                )}
              </Box>

              <Dialog
                open={openModerAlert}
                onKeyDown={handleEscape}
                PaperProps={{ id: "openedDlg" }}
                sx={{
                  "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                      width: "1400px",
                      maxWidth: "1400px",
                      height: "900px",
                      maxHeight: "900px",
                    },
                  },
                }}
              >
                <DialogContent>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "right",
                        pb: "10px",
                      }}
                    >
                      <Typography sx={{ width: "30%" }}>
                        UID:{" "}
                        <Link
                          href={
                            getAccountServerType() + "/" + param.row.author.sub
                          }
                          target="_blank"
                        >
                          {param.row.author.sub}
                        </Link>
                      </Typography>
                      <Typography sx={{ width: "30%" }}>
                        Nickname: {param.row.author.name}
                      </Typography>
                      <Typography sx={{ width: "30%" }}>
                        <Link
                          href={
                            getTemplatesServerType() +
                            "templates/userid/" +
                            param.row.author.sub
                          }
                          target="_blank"
                        >
                          Uploaded Template
                        </Link>
                      </Typography>
                      <HighlightOffIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          setModerAlert(false);
                        }}
                      />
                    </Box>
                  </Box>

                  <Box>
                    <DialogContentText
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: imgWidth < 200 ? "15px" : "70px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "48px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <ArrowBackIosIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => backImage(imageIndex - 1)}
                        />
                      </Box>
                      &nbsp;
                      <Box
                        sx={{
                          width: "700px", // 고정된 너비
                          height: "350px", // 고정된 높이
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {imageIndex > 4 ? (
                          <video
                            style={{
                              maxWidth: "700px",
                              width: imgWidth,
                              height: "350px",
                            }}
                            controls
                            autoPlay
                            ref={videoRef}
                          >
                            <source src={image} type="video/mp4" />
                          </video>
                        ) : (
                          <img
                            style={{
                              maxWidth: "700px",
                              width: imgWidth,
                              height: "350px",
                              border: "1px solid",
                            }}
                            src={image}
                          />
                        )}
                        {/* {imageIndex > 4 ? (
                          <video
                            style={{
                              maxWidth: "700px",
                              width: `${
                                (Number(param.row.ratios.split(":")[0]) /
                                  Number(param.row.ratios.split(":")[1])) *
                                350
                              }px`,
                              height: "350px",
                            }}
                            controls
                            autoPlay
                            ref={videoRef}
                          >
                            <source src={image} type="video/mp4" />
                          </video>
                        ) : (
                          <img
                            style={{
                              maxWidth: "700px",
                              width: `${
                                (Number(param.row.ratios.split(":")[0]) /
                                  Number(param.row.ratios.split(":")[1])) *
                                350
                              }px`,
                              height: "350px",
                              border: "1px solid",
                            }}
                            src={image}
                          />
                        )} */}
                      </Box>
                      &nbsp;
                      <Box
                        sx={{
                          width: "48px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "right",
                        }}
                      >
                        <ArrowForwardIosIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => forwardImage(imageIndex + 1)}
                        />
                      </Box>
                    </DialogContentText>
                    <DialogContentText
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {imageIndex > 4 ? (
                        <>
                          <Box
                            sx={{
                              textAlign: "center",
                              margin: "0 auto",
                              pt: 1,
                            }}
                          >
                            VIDEO
                            {[1, 2, 3, 4].map((speedOption) => (
                              <Button
                                sx={{
                                  pl: "0px",
                                  pr: "0px",

                                  minWidth: "25px !important",
                                  width: "25px !important",
                                  "&&.Mui-disabled": {
                                    color: "#6750A4",
                                    fontSize: "17px",
                                  },
                                  height: "17px",
                                }}
                                key={speedOption}
                                onClick={() => handleSpeedChange(speedOption)}
                                disabled={speed === speedOption}
                              >
                                {speed === speedOption ? (
                                  <b>{speedOption + "x"}</b>
                                ) : (
                                  `${speedOption}x`
                                )}
                              </Button>
                            ))}
                          </Box>
                        </>
                      ) : (
                        <Typography sx={{ pt: 1 }}>
                          {" "}
                          Snapshot# {Number(imageIndex + 1)}
                        </Typography>
                      )}
                    </DialogContentText>
                    <DialogContentText
                      sx={{
                        mt: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "128px", // 고정된 너비
                          height: imgWidth < 200 ? "215px" : "145px",
                          // height: "215px", // 고정된 높이
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {param.row.thumbnailsPaths &&
                          param.row.thumbnailsPaths.map(
                            (item: any, index: number) => {
                              return (
                                <>
                                  {
                                    <ImageCard
                                      key={index}
                                      style={{
                                        height: "calc(100% - 5px)",
                                        maxWidth: "120px",
                                        minWidth: "120px",
                                        boxShadow: "none", // box-shadow 제거
                                      }}
                                    >
                                      <CardMedia
                                        component="img"
                                        className={
                                          imageIndex === index
                                            ? "selectedImage"
                                            : ""
                                        }
                                        sx={{
                                          border:
                                            imageIndex === index
                                              ? "2px solid red"
                                              : "",
                                        }}
                                        src={item}
                                        onClick={() => changeImage(index)}
                                      />
                                    </ImageCard>
                                  }
                                  &nbsp;
                                </>
                              );
                            }
                          )}

                        <ImageCard
                          key={5}
                          className={imageIndex === 5 ? "selectedImage" : ""}
                          style={{
                            height: `${
                              (Number(param.row.ratios.split(":")[1]) /
                                Number(param.row.ratios.split(":")[0])) *
                              120
                            }px`,
                            maxWidth: "120px",
                            minWidth: "120px",
                            paddingTop: "30px",
                            alignSelf: "flex-start",
                            marginTop: "1px",
                            position: "relative",
                          }}
                          onClick={() => changeImage(5)}
                        >
                          <CardMedia
                            component="img"
                            sx={{
                              width: "40px",
                              height: "40px",
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              cursor: "pointer",
                            }}
                            src={Assets.PlayButton}
                          />
                        </ImageCard>
                      </Box>
                    </DialogContentText>

                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box
                        className="use-scrollbar"
                        sx={{
                          flex: 1,
                          maxWidth: "570px",
                          height: "150px",
                          ml: 15,
                          overflowY: "scroll", // 수직 스크롤바를 항상 표시
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        <DialogContentText
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <Typography sx={{ minWidth: "100px" }}>
                            <b>Description</b>:
                          </Typography>

                          <Typography>
                            {forbiddenWord
                              ? wordMatching(
                                  param.row.translations[0].description,
                                  forbiddenWord
                                )
                              : `${param.row.translations[0].description}`}
                          </Typography>
                        </DialogContentText>

                        {kineInfo.complexity ? (
                          <>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              <b>
                                Template Resource:{" "}
                                {kineInfo.complexity?.videoClipCount +
                                  kineInfo.complexity?.imageClipCount +
                                  kineInfo.complexity?.audioClipCount +
                                  kineInfo.complexity?.transitionCount +
                                  kineInfo.complexity?.layerVideoCount +
                                  kineInfo.complexity?.layerImageCount +
                                  kineInfo.complexity?.layerTextCount +
                                  kineInfo.complexity?.layerHandwritingCount +
                                  kineInfo.complexity?.layerAssetCount}
                              </b>
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              - Clip{" "}
                              {kineInfo.complexity?.videoClipCount +
                                kineInfo.complexity?.imageClipCount +
                                kineInfo.complexity?.audioClipCount +
                                kineInfo.complexity?.transitionCount}
                              : Video({kineInfo.complexity?.videoClipCount}
                              ), Image Clip(
                              {kineInfo.complexity?.imageClipCount}
                              ), Audio({kineInfo.complexity?.audioClipCount}),
                              Transition(
                              {kineInfo.complexity?.transitionCount})
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              - Layer{" "}
                              {kineInfo.complexity?.layerVideoCount +
                                kineInfo.complexity?.layerImageCount +
                                kineInfo.complexity?.layerTextCount +
                                kineInfo.complexity?.layerHandwritingCount +
                                kineInfo.complexity?.layerAssetCount}
                              : Video(
                              {kineInfo.complexity?.layerVideoCount}
                              ), Image({kineInfo.complexity?.layerImageCount}),
                              Asset(
                              {kineInfo.complexity?.layerAssetCount}), Text(
                              {kineInfo.complexity?.layerTextCount}),
                              Handwriting(
                              {kineInfo.complexity?.layerHandwritingCount})
                            </DialogContentText>
                          </>
                        ) : (
                          <>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              <b>Template Resource</b> : Data not exist
                            </DialogContentText>
                          </>
                        )}

                        <DialogContentText
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          {detailLoading ? (
                            <>
                              <Box sx={{ minWidth: "120px" }}>
                                <b>Application</b>:{" "}
                                <CircularProgress
                                  size="1rem"
                                  sx={{ mt: "6px" }}
                                />
                              </Box>
                              <Box sx={{ minWidth: "120px" }}>
                                <b>App Version</b>:{" "}
                                <CircularProgress
                                  size="1rem"
                                  sx={{ mt: "6px" }}
                                />
                              </Box>

                              <Box sx={{ minWidth: "120px" }}>
                                <b>OS</b>:{" "}
                                <CircularProgress
                                  size="1rem"
                                  sx={{ mt: "6px" }}
                                />
                              </Box>
                            </>
                          ) : (
                            <>
                              <Box>
                                <b>Application</b>:{" "}
                                {appName === "kinemaster"
                                  ? "KineMaster"
                                  : "Spring"}{" "}
                              </Box>
                              &nbsp;&nbsp;
                              <Box>
                                <b>App Version</b>: {appVersion}{" "}
                              </Box>
                              &nbsp;&nbsp;
                              <Box>
                                {" "}
                                <b>OS</b>: {OS}
                              </Box>
                            </>
                          )}
                        </DialogContentText>
                      </Box>
                      <Box
                        className="use-scrollbar"
                        sx={{
                          flex: 1,
                          maxWidth: "570px",
                          height: "150px",
                          overflowY: "scroll", // 수직 스크롤바를 항상 표시
                          whiteSpace: "pre-wrap",
                          ml: 1,
                        }}
                      >
                        <DialogContentText
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <Typography sx={{ minWidth: "150px" }}>
                            <b>Forbidden Word</b>:
                          </Typography>
                          <Typography sx={{ color: "red" }}>
                            <b>
                              {forbiddenWord
                                ? keywordString(forbiddenWord)
                                : ""}
                            </b>
                          </Typography>
                        </DialogContentText>
                      </Box>
                    </Box>
                    <DialogContentText
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        sx={{ p: "2.5px", position: "absolute", top: "850px" }}
                        variant="outlined"
                        onClick={() => {
                          setModerAlert(false);
                        }}
                      >
                        Close
                      </Button>
                    </DialogContentText>
                  </Box>
                </DialogContent>
              </Dialog>
            </>
          );
        },
        hide: this.headerStatus.includes("thumbnail"),
      },
      {
        field: "langAndRegion",
        headerName: "Lang/Region",
        width: 130,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "reviewStatus",
        headerName: "Status",
        width: 140,
        align: "center",
        headerAlign: "center",
        hide: this.headerStatus.includes("reviewer"),
      },
      {
        field: "reviewer",
        headerName: "Reviewer",
        width: 140,
        renderCell: (param) => {
          if (
            param.row.reviewStatus === "In Review" &&
            param.row.reviewer === ""
          ) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListReviewerBtn template={param.row} />
              </div>
            );
          } else if (
            param.row.reviewStatus === "Published" &&
            param.row.reviewer === ""
          ) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Avatar
                  alt="KineMaster"
                  src="https://resource.kinemaster.com/www/favicon.ico"
                />
              </div>
            );
          } else {
            return param.row.reviewer;
          }
        },
        hide: this.headerStatus.includes("reviewer"),
      },
      {
        field: "createdAt",
        headerName: "Uploaded Date",
        width: 240,
        align: "center",
        headerAlign: "center",
        hide: this.headerStatus.includes("createdAt"),
        renderHeader: (params) => {
          return (
            <div
              style={{
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* 특정 헤더를 커스텀 렌더링합니다. */}
              {params.colDef.headerName}

              {this.gridOption.sort === "desc" ? (
                <ArrowUpwardIcon
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              ) : (
                <ArrowDownwardIcon
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              )}
            </div>
          );
        },
      },
      {
        field: "operation",
        headerName: "Operation",
        width: 150,
        align: "center",
        headerAlign: "center",
        hide: this.headerStatus.includes("link"),
        renderCell: (param) => {
          return <ListModerationBtn template={param.row} />;
        },
      },
    ],

    rows: [],
    totalCount: 0,
    loading: true,
    page: Number(getCookie("mPage")) ? Number(getCookie("mPpage")) : 0,
    rowsPerPage: Number(getCookie("mRowsPerPage"))
      ? Number(getCookie("mRowsPerPage"))
      : 50,
    sort: getCookie("mSort") ? getCookie("mSort") : "desc",
  };

  setApplication = action((application: string) => {
    this.application = application;
  });

  setStatus = action((status: string) => {
    this.status = status;
  });

  setMixability = action((mixability: number) => {
    this.mixability = mixability;
  });

  setReference = action((reference: number) => {
    this.reference = reference;
  });

  setAsset = action((asset: number) => {
    this.asset = asset;
  });

  setEntertainment = action((entertainment: number) => {
    this.entertainment = entertainment;
  });

  setStartDate = action((startDate: Date) => {
    this.startDate = startDate;
  });

  setEndDate = action((endDate: Date) => {
    this.endDate = endDate;
  });

  setSearchText = action((searchText: string) => {
    if (searchText.slice(0, 1) !== " ") {
      this.searchText = searchText;
    }
  });

  setSearchOption = action((searchOption: string) => {
    this.searchOption = searchOption;
  });

  setGridOption = action((gridOption: any) => {
    this.gridOption = {
      ...this.gridOption,
      ...gridOption,
    };
  });
  setLanguageChange = action((value: any) => {
    this.language = value;
  });

  setCategoryChange = action((category: any) => {
    this.category = category;
  });

  setGacha = action((gacha: boolean) => {
    this.gacha = gacha;
  });

  setIsReviewer = action((isReviewer: boolean) => {
    this.isReviewer = isReviewer;
  });

  setBadge = action((badge: any) => {
    this.badge = badge;
  });

  onPageSizeChange = action((params: any) => {
    window.scrollTo(0, 0);
    this.gridOption.rowsPerPage = params;
  });

  onPageChange = action((params: any) => {
    window.scrollTo(0, 0);
    this.gridOption.page = params;
  });

  get getGridStatus() {
    return {
      page: this.gridOption.page + 1,
      display: this.gridOption.rowsPerPage,
      startedAt: this.startDate,
      endedAt: this.endDate,
      reviewStatus: this.status !== "All" ? this.status : undefined,
      searchType: this.searchText !== "" ? this.searchOption : undefined,
      searchText: this.searchText !== "" ? this.searchText : undefined,
    };
  }

  setRows = action(async () => {
    if (this.searchOption === "reviewer") {
      if (!this.searchText.includes("@") || !this.searchText.includes(".")) {
        alert("Please enter the full name including the domain.");
        return;
      }
    }

    const requestParameter = {
      page: this.gridOption.page + 1,
      display: this.gridOption.rowsPerPage,
      startedAt: this.startDate,
      endedAt: this.endDate,
      reviewStatus: this.status !== "All" ? this.status : undefined,
      searchType: this.searchText !== "" ? this.searchOption : undefined,
      searchText:
        this.searchText.trim() !== "" ? this.searchText.trim() : undefined,
      sort: this.gridOption.sort,
      language: this.language.value,
      category: this.category.value,
      mixability: this.searchOption === "score" ? this.mixability : undefined,
      reference: this.searchOption === "score" ? this.reference : undefined,
      asset: this.searchOption === "score" ? this.asset : undefined,
      entertainment:
        this.searchOption === "score" ? this.entertainment : undefined,
      application: this.application !== "all" ? this.application : "",
    };
    this.searchText = this.searchText.trim();
    this.gridOption.loading = true;
    this.gridOption.rows = [];
    await getTemplates(requestParameter)
      .then((data) => {
        if (data.response?.status) {
          const item = {
            action: "Get List",
            status: "Error",
            error: `get List (${data.response ? data.response.status : ""})`,
          };
          setTimeout(
            () =>
              postHistory(userEmail, item).catch((error) => {
                console.log("start review err", error);
              }),
            100
          );

          alert(
            `An error occurred while loading the template list. \nCode(${data.response.status})`
          );
        }

        localStorage.removeItem("reviewList");
        this.setGridOption({
          totalCount: data.totalCount,
          rows: data.templates.map((info: any) => {
            const reviewer = info.reviewer.split("@");
            return {
              ...info,
              id: info.templateId,
              thumbnail: info.imagePath,
              description: info.translations[0].description,
              createdAt: UtcDateFormatter(info.createdAt),
              userId: info.author.sub,
              name: info.author.name,
              langAndRegion: `${info.metaLanguageCode} / ${
                info.metaCountryCode.length >= 249
                  ? "All Country"
                  : info.metaCountryCode
              }`,
              reviewStatus:
                info.reviewStatus === "InReview"
                  ? "In Review"
                  : info.reviewStatus,
              reviewer: reviewer[0],
            };
          }),
        });
      })
      .catch((error) => {
        console.log(error);
        this.gridOption.totalCount = 0;
      })
      .finally(() => {
        this.gridOption.loading = false;
      });
  });

  searchHandler = action(async () => {
    // 검색어 없을시 모달을 띄울것인가?
    this.gridOption.page = 0;
    await this.setRows();
  });
}

export default ModerationStore;
